import { useState, useCallback } from "react";

export interface NewsItem {
  id: string;
  imageUrl: string;
  imageAlt: string;
  title: string;
  description: string;
}

export interface InfoCardData {
  id: string;
  title: string;
  description: string;
  image: string;
  className?: string;
}

export interface VideoData {
  id: string;
  url: string;
  title: string;
  description?: string;
}

export interface HomePageData {
  heroImage: string;
  netZeroCards: InfoCardData[];
  greenTransformCards: InfoCardData[];
  digitalTransformCards: InfoCardData[];
  kienTaoCards: InfoCardData[];
  newsItems: NewsItem[];
  featuredVideo: VideoData;
}

const useHomePageData = () => {
  // Static data - in real app, this would come from API
  const [data] = useState<HomePageData>({
    heroImage: "/KTX.1c089f91cb71463bcc54.gif",

    netZeroCards: [
      {
        id: "net-zero-1",
        title: "Net zero là gì?",
        description:
          "<p><strong>Net zero </strong>hay còn gọi là không phát thải ròng, hay phát thải ròng bằng 0 là việc cân bằng giữa lượng khí nhà kính (GHG) do các hoạt động (trực tiếp và gián tiếp) của con người thải vào bầu khí quyển và lượng khí nhà kính mà các hoạt động của con người có thể hấp thụ hoặc loại bỏ khỏi bầu khí quyển.</p>",
        image: "/netzero.jpg",
      },
    ],

    greenTransformCards: [
      {
        id: "green-1",
        title: "Vai trò của Chính phủ trong thực hiện mục tiêu net zero",
        description:
          "<p>Chính phủ đóng vai trò quan trọng trong việc đạt được mục tiêu net zero. Chính phủ hiện thực hóa các vai trò này thông qua các cơ chế chính sách sau:</p>",
        image: "/cp_b994.png",
        className: "mt-6",
      },
      {
        id: "green-2",
        title: "Vai trò của doanh nghiệp trong mục tiêu net zero",
        description:
          "<p>Doanh nghiệp đóng một vai trò cực kỳ quan trọng trong việc đạt được mục tiêu net zero. Vai trò này có thể hiện thông qua các mảng hoạt động sau đây:</p>",
        image: "/9862501.jpg",
        className: "mt-3",
      },
      {
        id: "green-3",
        title: "Vai trò của cộng đồng và người dân trong mục tiêu net zero",
        description:
          "<p>Cộng đồng và người dân có vai trò quan trọng trong việc thực hiện mục tiêu net zero. Vai trò này có thể thực hiện thông qua các mảng hoạt động sau.&nbsp;</p>",
        image: "/5734521.jpg",
        className: "mt-3",
      },
    ],

    digitalTransformCards: [
      {
        id: "digital-1",
        title: "Xu hướng chuyển đổi Số",
        description: `<div class="body-3 html-text-value"><p><strong>Chuyển đổi Số là gì?</strong></p><p>Chuyển đổi số: là quá trình thay đổi về tư duy và mô hình kinh doanh truyền thống sang mô hình kỹ thuật số, ứng dụng công nghệ thông tin vào vận hành.</p></div>`,
        image: "/frfr1ae9.jpg",
        className: "mt-6",
      },
    ],

    kienTaoCards: [
      {
        id: "kientao-1",
        title: "Tôn chỉ hoạt động Kiến Tạo Xanh Group",
        description:
          '<div class="body-3 html-text-value"><p>Tôn Chỉ Cộng Đồng: Văn Hóa Xanh<br>1. Văn hóa nhân bản<br>2. Văn hóa kiến tạo<br>3. Văn hóa phụng sự<br>4. Văn hóa bản địa</p></div>',
        image: "/56-459fcecd4cdb_f640.webp",
        className: "mt-6",
      },
    ],

    newsItems: [
      {
        id: "news-1",
        imageUrl:
          "https://images.unsplash.com/photo-1569163139394-de4798aa62b6?w=800&h=480&fit=crop",
        imageAlt: "COP29 Baku Azerbaijan conference",
        title:
          "COP29 đạt thỏa thuận hỗ trợ nước nghèo 300 tỷ USD chống biến đổi khí hậu",
        description:
          "Một thỏa thuận vừa được thông qua tại COP29, cam kết hỗ trợ 300 tỷ USD mỗi năm cho các nước nghèo và để bị tổn thương ứng phó biến đổi khí hậu.",
      },
      {
        id: "news-2",
        imageUrl:
          "https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&h=480&fit=crop",
        imageAlt: "World Toilet Day illustration",
        title: "Ngày Toilet thế giới",
        description:
          "Ngày Toilet Thế giới (World Toilet Day) là một ngày lễ quốc tế do Liên Hợp Quốc tổ chức vào ngày 19 tháng 11 hàng năm, nhằm kêu gọi hành động giải quyết cuộc khủng hoảng vệ sinh toàn cầu. Việc giải quyết các vấn đề vệ sinh không chỉ là vấn đề cá nhân mà còn là một bước tiến lớn trong nỗ lực xây dựng một thế giới khỏe mạnh, bình đẳng và bền vững.",
      },
      {
        id: "news-3",
        imageUrl:
          "https://images.unsplash.com/photo-1560707303-4e980ce876ad?w=800&h=480&fit=crop",
        imageAlt: "Bộ trưởng Huỳnh Thành Đạt tại hội trường",
        title:
          "Bộ trưởng Huỳnh Thành Đạt: Kinh tế xanh góp phần cho mục tiêu GDP trên 10%",
        description:
          'Sáng 16/11, tại hội trường chính biển ra phiên toàn thể với chủ đề "Kinh tế xanh - Động lực mới cho phát triển". Các chuyên gia trao đổi, thảo luận về cơ chế, chính sách, phương thức kích hoạt năng lực đổi mới sáng tạo và cộng hợp nguồn lực hiệu quả nhằm phát triển kinh tế xanh ĐBSCL. Ở năm thứ hai tổ chức, chương trình hút hơn 350 đại biểu từ Chính phủ, các Bộ, ngành, địa phương, chuyên gia và doanh nghiệp.',
      },
    ],

    featuredVideo: {
      id: "video-1",
      url: "https://www.youtube.com/watch?v=YyHTUscd-4E",
      title: "Video giới thiệu về KTX",
      description:
        "Video giới thiệu chi tiết về hệ thống quản lý nhà vệ sinh hiện đại, áp dụng công nghệ số hóa trong việc quản lý và vận hành. Hệ thống giúp tối ưu hóa quy trình, nâng cao trải nghiệm người dùng và hướng tới mục tiêu phát triển bền vững.",
    },
  });

  const handleNewsClick = useCallback((newsId: string) => {
    console.log(`Navigate to news article: ${newsId}`);
    // In real app, would navigate to news detail page
  }, []);

  const handleVideoClick = useCallback((videoId: string) => {
    console.log(`Play video: ${videoId}`);
    // In real app, would open video player or navigate
  }, []);

  return {
    data,
    handlers: {
      handleNewsClick,
      handleVideoClick,
    },
  };
};

export default useHomePageData;
